import { offsetPosition } from '../utils';
import { BUBBLE_BUTTON_SIZE } from '../components/LivechatBubbleButton';
const storageKey = 'livechat-button-position';
const getStoredItem = () => {
    const item = localStorage.getItem(storageKey);
    return item ? JSON.parse(item) : null;
};
export const savePosition = (position) => {
    const existingItem = getStoredItem();
    localStorage.setItem(storageKey, JSON.stringify({
        ...existingItem,
        [window.location.href]: {
            x: position.x,
            y: position.y,
        },
    }));
};
export const getPosition = (location) => {
    const defaultPosition = offsetPosition({
        x: document.documentElement.clientWidth - BUBBLE_BUTTON_SIZE,
        y: document.documentElement.clientHeight - BUBBLE_BUTTON_SIZE,
    }, -36);
    const storageItem = getStoredItem();
    return (storageItem === null || storageItem === void 0 ? void 0 : storageItem[location]) ? storageItem[location] : defaultPosition;
};
